import GamePage from "./GamePage";
import "./game-page.scss";

export default GamePage;
